import React from 'react';
import TeamMembersPage from './TeamMembersPage';

const FoundersPage = () => <TeamMembersPage mode="founders" />;

export default FoundersPage;
